import { configureStore } from "@reduxjs/toolkit";
import currentLocationReducer from "./StateManagement/currentLocationSlice";
import statisticSourceReducer from "./StateManagement/statisticSourceSlice";
import display3DReducer from "./StateManagement/display3DSlice";

export default configureStore({
  reducer: {
    currentLocation: currentLocationReducer,
    statisticSource: statisticSourceReducer,
    display3D: display3DReducer,

  },
});
